import { render, staticRenderFns } from "./SwitchToggle.vue?vue&type=template&id=5f3bc77e&scoped=true&"
import script from "./SwitchToggle.vue?vue&type=script&lang=ts&"
export * from "./SwitchToggle.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchToggle.vue?vue&type=style&index=0&id=5f3bc77e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3bc77e",
  null
  
)

export default component.exports